import { getDemoVisibleBounds } from './scroll-geometry'
import { createContext } from 'react'

export const DemoPlayerContext = createContext<DemoPlayerContextValue | undefined>(undefined)

let activeClock: DemoPlayerClock | undefined

export const setDemoPlayerClock = (clock?: DemoPlayerClock) => {
  activeClock = clock
}

export const getDemoPlayerClock = () => activeClock

const waitForPlaybackTime = ({ duration, realTime }: DemoPlaybackWaitParams) => {
  const clock = activeClock

  if (!clock) {
    return new Promise<void>(resolve => window.setTimeout(resolve, duration))
  }

  return new Promise<void>((resolve, reject) => {
    const signal = clock.controller.signal
    let remaining = duration
    let previous = performance.now()
    let timer: ReturnType<typeof setTimeout>

    const abort = () => {
      clearTimeout(timer)
      reject(new DOMException('Playback cancelled', 'AbortError'))
    }

    const tick = () => {
      if (signal.aborted) {
        abort()
        return
      }

      const now = performance.now()

      const player = document.querySelector('.demo-player')
      const waitingForVisiblePlayer = Boolean(player && !getDemoVisibleBounds(player))
      const waitingForManualScroll = now < clock.manualScrollUntil || waitingForVisiblePlayer
      if (!clock.paused && !waitingForManualScroll) {
        remaining -= (now - previous) * (realTime ? 1 : clock.speed)
      }

      previous = now

      if (!clock.paused && !waitingForManualScroll && remaining <= 0) {
        signal.removeEventListener('abort', abort)
        resolve()
        return
      }

      timer = setTimeout(tick, 16)
    }

    signal.addEventListener('abort', abort, { once: true })
    tick()
  })
}

export const waitForDemoPlayback = (duration: number) => waitForPlaybackTime({ duration })

export const waitForDemoReading = (duration: number) => waitForPlaybackTime({ duration, realTime: true })
